import { format } from "date-fns";

const useEditorVerify = ({
  requestPost,
  uiContext,
  headerData,
  setHeaderData,
  setPengecekanBerangkatData,
  setPengecekanKembaliData
}) => {
  // API call
  const saveTanggalToNow = async (type, data) => {
    const now = new Date();
    const body = { ...data, tanggal: format(now, "yyyy-MM-dd HH:mm:ss") };
    requestPost({
      fullUrl: `/api/pemakaian/pengecekanmobil/save`,
      body,
      isForm: false,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: responseData, message }) => {
        // uiContext.showSuccessMsg("Success", message);
        if (type === "berangkat") {
          setHeaderData({ ...headerData, tanggal_berangkat: now });
          setPengecekanBerangkatData(responseData);
        } else {
          setHeaderData({ ...headerData, tanggal_pulang: now });
          setPengecekanKembaliData(responseData);
        }
      },
    });
  };

  const verify = async ({
    username,
    password,
    verifLabel,
    id,
    result_object_id,
    result_object_datetime,
    result_object_data,
    data,
    setData,
  }) => {
    const body = { data_id: id, label: verifLabel };
    if (username) body["username"] = username;
    if (password) body["password"] = password;

    // console.log("VERIF", body);

    return await requestPost({
      fullUrl: `api/user/verif`,
      body: body,
      onSuccess: ({ message, data: responseData }) => {
        if (responseData) {
          const newData = { ...data };
          newData[result_object_id] = responseData[result_object_id];
          newData[result_object_datetime] =
            responseData[result_object_datetime];
          newData[result_object_data] = responseData[result_object_data];
          setData(newData);

          uiContext.showSuccessMsg("Success", "Verifikasi berhasil");
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  return {
    saveTanggalToNow,
    verify
  };
};

export default useEditorVerify;
